import { Container } from "@mui/system"
import React, { FC } from "react"
import { Login } from "../../components/auth/login"
import { Box, Paper } from "@mui/material"
import { Auth } from "../../components/auth/auth"

interface ILoginProps {}

export const LoginPage: FC<ILoginProps> = (props) => {
  return (
    <Container maxWidth={"xs"}>
      <Paper elevation={3}>
        <Box p={3}>
          <Login />
          <Auth />
        </Box>
      </Paper>
    </Container>
  )
}
